
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/laser-blast",
      function () {
        return require("private-next-pages/laser-blast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/laser-blast"])
      });
    }
  